import MobileNewsDetail from '~mobile/pages/news/news-detail.vue'
import DesktopNewsDetail from '~desktop/pages/news/news-detail.vue'
import DesktopInstructionPage from '~desktop/pages/instruction/index.vue'
import MobileInstructionPage from '~mobile/pages/instruction/index.vue'
import DesktopIFrame from '~desktop/pages/iframes/index.vue'
import ResetPasswordPage from '~/components/desktop/auth/form-reset-password.vue'
import { usePageByDevice } from '~/composables/common/use-page-by-device'
import {
  ModalCollection,
  SLUG_NEWS,
  IGNORE_SLUGS,
  RESET_PASSWORD_SLUG,
  PROMOTION_SLUG,
  SIMPLE_PAGE_SLUG
} from '~/constants'

import { IFRAME_GAME_URLS } from '~/configs/page-url'

import { useGames } from '~/composables/games/use-games'
import { useModal } from '~/composables/common/use-modal'

type SlugType = string | undefined | boolean

const slugType = {
  IFRAMES: 'IFRAMES',
  NEWS_SLUG: 'NEWS_SLUG',
  NEWS_DETAIL: 'NEWS_DETAIL',
  PROMOTION_SLUG: 'PROMOTION_SLUG',
  SIMPLE_PAGE_SLUG: 'SIMPLE_PAGE_SLUG',
  RESET_PASSWORD_SLUG: 'RESET_PASSWORD_SLUG'
}

export function useSlug() {
  const route = useRoute()
  const router = useRouter()
  const { isMobile } = useDevice()
  const params = route.params
  const { component: componentNewsDetail } = usePageByDevice(DesktopNewsDetail, MobileNewsDetail)

  const { component: componentInstructionPage } = usePageByDevice(DesktopInstructionPage, MobileInstructionPage)
  const componentResetPasswordPage = ResetPasswordPage

  const { getPlayGameUrl, getIframeGameMapGameApi } = useGames()
  const { openModal } = useModal()

  const handleSlug = async (): Promise<SlugType> => {
    try {
      return await validateSlug(params.slug?.toString()?.replace('.html', ''))
    } catch {
      void router.replace('/404')
    }
  }

  async function getCurrentComponent(type: SlugType): Promise<Component | undefined> {
    switch (type) {
      case slugType.IFRAMES:
        if (isMobile) {
          const urlResponse = (await getPlayGameUrl(getIframeGameMapGameApi(`/${params.slug.toString()}`)))?.content
          if (urlResponse) {
            window.location.href = urlResponse
          }
        }
        return DesktopIFrame

      case slugType.SIMPLE_PAGE_SLUG:
        return componentInstructionPage
      case slugType.NEWS_DETAIL:
        return componentNewsDetail
      case slugType.RESET_PASSWORD_SLUG:
        return componentResetPasswordPage
    }
  }

  async function validateSlug(slug: string): Promise<SlugType> {
    const iframeUrl = Object.values(IFRAME_GAME_URLS).find(item => params.slug.toString() === item.slice(1))

    if (iframeUrl) {
      return slugType.IFRAMES
    } else if (slug === RESET_PASSWORD_SLUG) {
      openModal(ModalCollection.RESET_PASSWORD)
      return
    } else if (slug === PROMOTION_SLUG) {
      return slugType.PROMOTION_SLUG
    } else if (SIMPLE_PAGE_SLUG.includes(slug)) {
      return slugType.SIMPLE_PAGE_SLUG
    } else if (slug === SLUG_NEWS.PAGE) {
      return slugType.NEWS_SLUG
    } else if (!IGNORE_SLUGS.includes(slug)) {
      const newSlug = params?.slug?.toString()
      if (newSlug.includes('.html')) {
        return slugType.NEWS_DETAIL
      }
    }
    throw new Error('404')
  }

  return { handleSlug, getCurrentComponent, slugType }
}
